module.exports = __webpack_public_path__ + "static/2-c697a8b435c4db377874869f969b5fb4.jpg";